module.exports = __webpack_public_path__ + "static/media/fullhousessi.ab1abb11.jpeg";